/*
 * The store register is used to provide access to the Redux
 * stores of React components currently mounted on the page. It
 * is useful if JavaScript code outside the store needs to make
 * changes to the state of the store.
 */
const registered = {};

function register(id, store) {
  if (registered[id]) {
    console.warn(`Overriding previously registered store: ${id}`);
  }
  registered[id] = store;
}

function get(id) {
  if (!isRegistered(id)) {
    console.warn(
      `[StoreRegister] You're trying to get a store (${id}) that is not registered.`
    );
  }
  return registered[id];
}

function deregister(id) {
  delete registered[id];
}

function isRegistered(id) {
  return Boolean(registered[id]);
}

export default {
  register,
  get,
  deregister,
  isRegistered,
};
